class CollectionFilters {
  constructor() {
    this.drawer = document.getElementById('collection-filters-drawer');
    this.filterButton = document.querySelector('.filter-button');
    this.closeButton = document.querySelector('.close-filters-button');
    this.applyButton = document.querySelector('.apply-filters');
    this.resetButton = document.querySelector('.reset-filters');
    this.filterGroups = this.drawer.querySelectorAll('.filter-group');

    this.bindEvents();
    this.initializeCollapsibles();
  }

  initializeCollapsibles() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group__header');
      const content = group.querySelector('.filter-options');
      
      // Si le groupe a des filtres actifs, l'ouvrir par défaut
      const hasActiveFilters = group.querySelector('input:checked');
      if (hasActiveFilters) {
        this.toggleCollapsible(header, content, true);
      }

      header.addEventListener('click', () => {
        this.toggleCollapsible(header, content);
      });
    });
  }

  toggleCollapsible(header, content, forceOpen = null) {
    const isExpanded = forceOpen !== null ? !forceOpen : header.getAttribute('aria-expanded') === 'true';
    
    header.setAttribute('aria-expanded', (!isExpanded).toString());
    
    if (!isExpanded) {
      content.hidden = false;
      // Obtenir la hauteur réelle
      const height = content.scrollHeight;
      content.style.height = '0';
      // Forcer un reflow
      content.offsetHeight;
      content.style.height = height + 'px';
      
      content.addEventListener('transitionend', () => {
        content.style.height = '';
      }, { once: true });
    } else {
      content.style.height = content.scrollHeight + 'px';
      // Forcer un reflow
      content.offsetHeight;
      content.style.height = '0';
      
      content.addEventListener('transitionend', () => {
        content.hidden = true;
        content.style.height = '';
      }, { once: true });
    }
  }

  bindEvents() {
    // Ouvrir le drawer
    this.filterButton?.addEventListener('click', () => this.openDrawer());

    // Fermer le drawer
    this.closeButton?.addEventListener('click', () => this.closeDrawer());

    // Réinitialiser les filtres
    this.resetButton?.addEventListener('click', () => this.resetFilters());

    // Appliquer les filtres
    this.applyButton?.addEventListener('click', () => this.applyFilters());

    // Gérer la touche Echap
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeDrawer();
    });
  }

  openDrawer() {
    this.drawer.classList.add('active');
    this.filterButton.setAttribute('aria-expanded', 'true');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  closeDrawer() {
    this.drawer.classList.remove('active');
    this.filterButton.setAttribute('aria-expanded', 'false');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  resetFilters() {
    // Rediriger vers l'URL de la collection sans paramètres
    window.location.href = window.location.pathname;
  }

  applyFilters() {
    // Créer un formulaire pour soumettre les filtres
    const form = document.createElement('form');
    form.method = 'get';
    form.action = window.location.pathname;

    // Ajouter les filtres cochés au formulaire
    this.drawer.querySelectorAll('input[type="checkbox"]:checked').forEach(checkbox => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = checkbox.name;
      input.value = checkbox.value;
      form.appendChild(input);
    });

    // Ajouter les filtres de prix s'ils sont définis
    const priceRange = this.drawer.querySelector('.price-range');
    if (priceRange) {
      const minPrice = priceRange.querySelector('.price-range__value:first-child .price-range__input')?.value;
      const maxPrice = priceRange.querySelector('.price-range__value:last-child .price-range__input')?.value;
      
      if (minPrice) {
        const minPriceInput = document.createElement('input');
        minPriceInput.type = 'hidden';
        minPriceInput.name = 'filter.v.price.gte';
        minPriceInput.value = minPrice;
        form.appendChild(minPriceInput);
      }

      if (maxPrice) {
        const maxPriceInput = document.createElement('input');
        maxPriceInput.type = 'hidden';
        maxPriceInput.name = 'filter.v.price.lte';
        maxPriceInput.value = maxPrice;
        form.appendChild(maxPriceInput);
      }
    }

    // Ajouter un paramètre pour indiquer que les filtres sont actifs
    const filterActiveInput = document.createElement('input');
    filterActiveInput.type = 'hidden';
    filterActiveInput.name = 'filter.v.availability';
    filterActiveInput.value = 'true';
    form.appendChild(filterActiveInput);

    // Soumettre le formulaire
    document.body.appendChild(form);
    form.submit();
  }
}

// Initialiser les filtres quand le DOM est chargé
document.addEventListener('DOMContentLoaded', () => {
  new CollectionFilters();
});